import React, { Fragment } from "react";
import { ImagePopout } from "components/image-stream/image-popout";

import DownloadImage from "./download-image";

const UneditedImage = (props) => {
    const timestamp = Math.round(new Date().getTime() / 1000);
    const { wipKey, shot, mimeType, shipmentKey, shipmentProductKey, sourcePage } = props;

    return (
        <Fragment>
            <div className="og-image">
                <ImagePopout
                    photoKey={shot.key}
                    imageUris={shot.uneditedImageUris}
                    shipmentKey={shipmentKey}
                    shipmentProductKey={shipmentProductKey}
                    alt={shot.imageView}
                    imageSize="medium"
                    timeStamp={timestamp}
                />
            </div>
            <div className="og-control">
                <div className="message">&nbsp;</div>
                {props.children}
                <div className="button-group">
                    <DownloadImage
                        sourcePage={sourcePage}
                        title="Download Unedited Image"
                        wipKey={wipKey}
                        type="unedited"
                        shotKey={shot.key}
                        mimeType={mimeType}
                        imageView={shot.imageView}
                        isReadOnly={props.roDownload}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default UneditedImage;
